import { initWasmModule } from '@/wasm/wasm'

/**
 * Initialize WASM early in app lifecycle
 * Call this once when the app starts
 */
export async function initRulerWasm(): Promise<void> {
  try {
    await initWasmModule()
  } catch (error) {
    console.warn('Failed to initialize WASM, will fallback to JS:', error)
  }
}
